import Modules from './_Modules';

// create singleton instance
export const modules = window.__sbgModules || new Modules();

// Only export the initialize method from the core module library
export const initializeModules = window.__sbgModules ?
  Function.prototype : modules.initialize.bind(modules);

// bind all these helpers to the instance so they can be used as callbacks
export const getComponentsForModule   = modules.getComponentsForModule.bind(modules);
export const getModuleButtons         = modules.getModuleButtons.bind(modules);
export const getModuleRoutes          = modules.getModuleRoutes.bind(modules);
export const getModules               = modules.getModules.bind(modules);
export const getSiteMapActions        = modules.getSiteMapActions.bind(modules);
export const getVisibleModuleButtons  = modules.getVisibleModuleButtons.bind(modules);
export const showModule               = modules.showModule.bind(modules);
export const hideModule               = modules.hideModule.bind(modules);
export const listenForModuleUpdates   = modules.listenForModuleUpdates.bind(modules);
export const loadModulesForUser       = modules.loadModulesForUser.bind(modules);
export const registerModule           = modules.registerModule.bind(modules);
export const removeListener           = modules.removeListener.bind(modules);
export const removeModule             = modules.removeModule.bind(modules);
export const setModuleRoutes          = modules.setModuleRoutes.bind(modules);

export const getDependencies          = modules.getDependencies.bind(modules);

export default {
  getComponentsForModule,
  getDependencies,
  getModuleButtons,
  getModuleRoutes,
  getModules,
  getSiteMapActions,
  getVisibleModuleButtons,
  showModule,
  hideModule,
  initializeModules,
  listenForModuleUpdates,
  loadModulesForUser,
  registerModule,
  removeListener,
  removeModule,
  setModuleRoutes,
};

// Setup a global hook for other bundles
window.__sbgModules = modules;
